import { Actions, Reducer } from "./SolutionSlice";
import * as Selectors from "./SolutionSelectors";
import * as Thunks from "./SolutionThunk";

const SolutionState = {
  Actions,
  Selectors,
  Thunks,
};

export { Reducer };

export default SolutionState;
